export const faqData = [
  {
    question: "How long does it take for purchased credits to arrive?",
    answer:
      "Telegram Stars payments usually arrive instantly (within 1 minute).",
  },
  {
    question: "Why didn't the credits arrive after I purchased via Telegram?",
    answer:
      "If your credits haven't arrived after purchasing via Telegram, please check your transaction history first. If the transaction shows as completed but credits are missing, contact our support team with your transaction ID.",
  },
  {
    question: "What is the validity period of my subscription or credits?",
    answer:
      "Subscription credits are valid for the duration of your active subscription plus 30 days after cancellation. One-time credit purchases are valid for 1 year from the date of purchase.",
  },
  {
    question: "How can I cancel my subscription?",
    answer:
      "You can cancel your subscription at any time from your account settings. Your subscription will remain active until the end of the current billing period, and you'll retain access to all features until then.",
  },
  {
    question: "How do I delete my account?",
    answer: (
      <span>
        If you wish to permanently delete your account, you can do so by
        visiting our{" "}
        <a
          href="/account/delete"
          style={{
            color: "#2877d9",
            textDecoration: "none",
          }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          account deletion page
        </a>
        . Please note that this action is permanent and will erase all your
        credits, videos, and personal data. This cannot be undone.
      </span>
    ),
  },
];
